export default "__VITE_ASSET__99b663f9__"